export const USERS_PAGE_SIZE = 25;

export const EMPTY_USER_FORM = {
  email: '',
  password: '',
  firstName: '',
  lastName: '',
  phone: '',
  jobPosition: '',
  workArea: '',
  role: 'user',
  unit: '',
};

export const USER_ACTIONS_POPPER_CONFIG = {
  strategy: 'fixed',
  modifiers: [
    {
      name: 'preventOverflow',
      options: {
        boundary: 'viewport',
        padding: 8,
      },
    },
    {
      name: 'flip',
      options: {
        fallbackPlacements: ['top-end', 'bottom-end'],
      },
    },
  ],
};
